import { intl } from 'lang/intl'

/**
 * A commenter's display name, annotated with the alias they posted under when
 * the two differ.
 */
const formatSenderName = (name: string, fullName: string) => {
  if (!fullName) return name
  if (fullName === name) return fullName

  return `${fullName} ${intl.formatMessage(
    { defaultMessage: '(shown as {name})', id: 'wyHi2v' },
    { name }
  )}`
}

export { formatSenderName }
